import { Box, BoxProps, Skeleton, SkeletonProps } from '@mui/material';
import React from 'react';
type EditableTitleSkeletonProps = {
  boxStyles?: BoxProps['sx'];
  skeletonStyles?: SkeletonProps['sx'];
  showCircle?: boolean;
};
function EditableTitleSkeleton({
  boxStyles = {},
  skeletonStyles = {},
  showCircle = false,
}: EditableTitleSkeletonProps) {
  return (
    <>
      <Box
        display='flex'
        justifyContent='center'
        alignContent='center'
        gap={2}
        sx={{ paddingLeft: 1, paddingRight: 1, ...boxStyles }}
      >
        {showCircle && (
          <Skeleton
            variant='circular'
            sx={{
              width: '40px',
              height: '40px',
              ...skeletonStyles,
            }}
          />
        )}
        <Skeleton
          variant='text'
          sx={{
            fontSize: '1.6rem',
            width: '150px',
            ...skeletonStyles,
          }}
        />
      </Box>
    </>
  );
}

export default EditableTitleSkeleton;
